import getItemsSorted from './getItemsSorted'

const getMovieSortedByTitle = movieData => getItemsSorted(_.keys(movieData), movieData)

export default getMovieSortedByTitle